// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"389a7720","164":"f42f0467","746":"e41177b8","929":"2d9af5b2","941":"6433d9f9","992":"9e53db50"}[chunkId] + ".chunk.js";
};